type CollaborationChannelPost = {
  _id?: string | null;
  schedule?: { channel?: string | null } | null;
  channel?: string | null;
};

/**
 * Collaboration comments are keyed by channel, not by post id. Draft-backed
 * scheduled posts retain the channel under schedule.channel while posts
 * created directly on the calendar use the top-level channel.
 */
export const resolveCollaborationChannelId = (
  post: CollaborationChannelPost | null | undefined
): string | null => {
  if (!post) return null;
  return (
    [post.schedule?.channel, post.channel, post._id].find(
      (candidate): candidate is string =>
        typeof candidate === "string" && candidate.trim().length > 0
    ) ?? null
  );
};
